import { Routes } from '@angular/router';
import { RealmAttributesForm } from './components/realm-attributes-form/realm-attributes-form';
import { ClientsList } from './components/clients-list/clients-list';
import { ClientAttributesForm } from './components/client-attributes-form/client-attributes-form';
import { RealmOverview } from './components/realm-overview/realm-overview';
import { UsersList } from './components/users-list/users-list';
import { UserEdit } from './components/user-edit/user-edit';
import { GroupsList } from './components/groups-list/groups-list';
import { GroupEdit } from './components/group-edit/group-edit';
import { CreateClient } from './components/create-client/create-client';
import { RequestClient } from './components/request-client/request-client';
import { MyClientRequests } from './components/my-client-requests/my-client-requests';
import { ClientRequestsAdmin } from './components/client-requests-admin/client-requests-admin';

export const routes: Routes = [
  {
    path: '',
    component: RealmOverview,
  },
  {
    path: 'attributes',
    component: RealmAttributesForm,
  },
  {
    path: 'clients',
    component: ClientsList,
  },
  {
    path: 'clients/create',
    component: CreateClient,
  },
  {
    path: 'clients/request',
    component: RequestClient,
  },
  {
    path: 'client-requests/mine',
    component: MyClientRequests,
  },
  {
    path: 'client-requests',
    component: ClientRequestsAdmin,
  },
  {
    path: 'clients/:id',
    component: ClientAttributesForm,
  },
  {
    path: 'users',
    component: UsersList,
  },
  {
    path: 'users/:id',
    component: UserEdit,
  },
  {
    path: 'groups',
    component: GroupsList,
  },
  {
    path: 'group/:id',
    component: GroupEdit,
  },
];
